import { APIError } from "errors";
import api from "../api";

const INITIAL_STATE = {
  notes: undefined,
  note: undefined,
  error: undefined,
  loading: false
};

// ----------> MODEL <----------

export const notes = {
  state: INITIAL_STATE,

  reducers: {
    setNotes(state, notes) {
      return { ...state, notes };
    },

    setLoading(state, loading) {
      return { ...state, loading };
    },

    setError(state, error) {
      return { ...state, error };
    },

    purge() {
      return {
        ...INITIAL_STATE
      };
    }
  },
  effects: (dispatch) => ({
    fetchNotes: async (payload, rootState) => {
      try {
        const user = rootState.user.user;
        const userId = user?.id;

        dispatch.notes.setLoading(true);

        const { data: notes } = await api.post(`/notes?owner=${userId}`, payload);

        dispatch.notes.setNotes(notes.data);
      } catch (error) {
        dispatch.notes.setNotes([]);

        if (error instanceof APIError) {
          dispatch.app.setLastAPIError(error);

          // TODO: implement model specific lastapierror
          // dispatch.notes.setLastAPIError({
          //   lastAPIError: error,
          //   lastAPIErrorEffect: "fetch",
          // });
        } else {
          dispatch.notes.setError(error);
        }

        throw error;
      } finally {
        dispatch.notes.setLoading(false);
      }
    }
  })
};
